'use client';

/* ──────────────────────────────────────────────
 *  RedirectPaymentNotice — banner shown when a
 *  tunnel resumes after a Stripe redirect (Klarna…).
 *  Shared by the bt-* tunnels (booking, ride, gift card).
 * ────────────────────────────────────────────── */

import type { JSX } from 'react';
import type { RedirectReturnPhase } from '../../../pro-payment/useRedirectReturn';

interface RedirectPaymentNoticeProps {
  phase: RedirectReturnPhase;
  message: string;
}

export function RedirectPaymentNotice({ phase, message }: RedirectPaymentNoticeProps): JSX.Element {
  const isAlert = phase === 'failed' || phase === 'unverified' || phase === 'expired';
  return (
    <div className={`bt-redirect-notice bt-redirect-notice--${phase}`} role={isAlert ? 'alert' : 'status'}>
      <span className="bt-redirect-notice__icon">
        <svg
          viewBox="0 0 24 24"
          width="20"
          height="20"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <circle cx="12" cy="12" r="10" />
          {isAlert ? (
            <>
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </>
          ) : (
            <polyline points="12 6 12 12 16 14" />
          )}
        </svg>
      </span>
      <span className="bt-redirect-notice__message">{message}</span>
    </div>
  );
}
